<script>
    export default {
        data: function () {
            return {
                active: false,
                scrollbarWidth: null
            }
        },
        watch: {
            active: function(value) {
                if(value) {
                    $('body, #in-calc-footer, footer').css('padding-right', this.scrollbarWidth+'px')
                    $('body').css('overflow', 'hidden')
                } else {
                    $('body, #in-calc-footer, footer').css('padding-right', 0)
                    $('body').css('overflow', 'auto').css('overflow-y', 'scroll')
                }
            }
        },
        created() {
            window.addEventListener('keyup', this.keyUp)
            this.scrollbarWidth = this.getScrollbarWidth()
        },
        methods: {
            closeModal: function () {
                this.active = false
                this.$store.modalOpen = false
            },
            keyUp(e) {
                if (e.keyCode == 27) {
                    this.closeModal()
                }
            },
            getScrollbarWidth() {
                var outer = document.createElement("div")
                outer.style.visibility = "hidden"
                outer.style.width = "100px"
                outer.style.msOverflowStyle = "scrollbar"

                document.body.appendChild(outer)

                var widthNoScroll = outer.offsetWidth
                // force scrollbars
                outer.style.overflow = "scroll"

                // add innerdiv
                var inner = document.createElement("div")
                inner.style.width = "100%"
                outer.appendChild(inner)

                var widthWithScroll = inner.offsetWidth

                // remove divs
                outer.parentNode.removeChild(outer)

                return widthNoScroll - widthWithScroll
            }
        }
    }
</script>